export default "__VITE_ASSET__BU5Ez30Y__"